import EventEmitter from 'event-emitter';

const events = new EventEmitter();

let user = loadCredentials();

export function setUser(data) {
  user = data;
  saveCredentials(data);
  events.emit('user:changed', user);
}

export function getUser() {
  return user;
}

export function onUserChange(onChange) {
  events.on('user:changed', onChange);
}

function saveCredentials(values) {
  localStorage.setItem('mos_data', JSON.stringify(values));
}

function loadCredentials() {
  let data = localStorage.getItem('mos_data');
  if(data) {
    data = JSON.parse(data);
    return data;
  }
}

export function isAuthorized() {

}



// WEBPACK FOOTER //
// ./src/helpers/session.js